module.exports = __webpack_public_path__ + "static/human_female_turami-dd63f0974338cbde28c4da43a737e2a2.png";